import { MediasPublicModels } from '@features/products/medias';

const regexMp4 = /mp4/i;
const regexHls = /m3u8/i;

export function amandaProcessUrl(url: string, width?: string): string {
    if (!url) return null;

    const urlObj = new URL(url);

    urlObj.searchParams.delete('idMedia');

    if (width && urlObj.searchParams.get('w')) {
        urlObj.searchParams.set('w', width);
        return urlObj.toString();
    }

    urlObj.searchParams.delete('w');
    return urlObj.toString();
}

export function amandaProcessMedias(medias: MediasPublicModels.PublicMedia[]): MediasPublicModels.PublicMedia[] {
    return medias.map((media) => {
        return {
            ...media,
            path: amandaProcessUrl(media.path),
        };
    });
}

export function getPosterVideo(mediaUrlVideo) {
    if (regexHls.test(mediaUrlVideo)) {
        return mediaUrlVideo.replace(regexHls, 'jpg');
    }
    return mediaUrlVideo.replace(regexMp4, 'jpg');
}
